interface IOfferPayload {
    catalogOfferCode: string;
    prequalId?: string;
}

export const getStateToPayload = (catalogOfferCode: string, prequalId?: string): IOfferPayload => ({
    catalogOfferCode,
    prequalId,
});
